import {
    Box,
    Typography
} from '@mui/material';
import { useState } from 'react';
import PointIcon from '../icons/Point';
import ChallengeCardInfo from '../infomodals/ChallengeCardInfo';

export default function ChallengeCard({ uid, cid, details, photo, setOpenChallenge }) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
        setOpenChallenge(true); 
    }

    return (
        <div>
            {/* Minimized Card */}
            <Box
                sx={{ 
                    backgroundColor: (details?.type==='weekly'||details?.type==='day') ? 'var(--pri-yellow)' : 'var(--pri-green)', 
                    borderRadius: '32px', 
                    cursor: 'pointer',
                    transition: 'box-shadow 0.5s, transform 0.5s',
                    '&:hover' : {
                        transform: 'translate(-4px,-4px)',
                        boxShadow: `4px 4px var(--dark-${(details?.type==='weekly'||details?.type==='day') ? 'yellow': 'green'})`,
                    }
                }}
                onClick={handleOpen}
            >
                <Box sx={{ width: '100%', borderRadius: '32px 32px 0 0', aspectRatio: 1, background: `var(--light-green) url(${photo}) no-repeat center`, backgroundSize: 'cover' }} />

                <Box sx={{ p: 2 }}>
                    <Typography variant='subtitle2'>
                        { details?.title }
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>    
                        <Box className='centered-x'>
                            <Typography variant='caption'>
                                { details?.points }
                                &nbsp;
                            </Typography>
                            <PointIcon />
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Fullscreen Card */}
            <ChallengeCardInfo
                uid={uid} 
                cid={cid} 
                details={details} 
                photo={photo} 
                setOpenChallenge={setOpenChallenge} 
                setOpen={setOpen}
                open={open}
            />
        </div>
        
    )
}